import React from "react";
import { useState, useEffect } from "react";
import useQuery from "../../hook/useQuery";
import CardCentral from "../../components/Card";
import Typography from "@material-ui/core/Typography";
import useStyles from "./style";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import { Button, Link, Checkbox } from "@material-ui/core";
import { Link as RouterLink, useHistory, useLocation } from "react-router-dom";

import UsuarioService from "../../services/usuarioService";
import { useAuth } from "../../auth/ProvideAuth";

const SingUp = (props) => {
  const location = useLocation();
  const is403 = location.state ? location.state.is403 : null;
  const redirect_rel = location.state ? location.state.redirect_rel : null;

  const auth = useAuth();

  const history = useHistory();
  const classes = useStyles();

  const query = useQuery();

  
  const [error, setErro] = useState({ isError: false, erroMsg: "" });
  const [name, setName] = useState("");
  const [document, setDocument] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordConfirmation, setPassWordConfirmation] = useState("");
  const [checked, setChecked] = useState(false);
  const [disabled, setDisabled] = useState(true);
  
  const fields = [name,document,email,password,passwordConfirmation,checked];



  const entrar = async (event) => {
    event.preventDefault();
    try {
      let res = await UsuarioService.login(email, senha);

      auth.signin(() => {
        if (redirect_rel) {
          history.goBack();
        } else {
          history.push("/");
        }
      });
    } catch (e) {
      setErro({ isError: true, erroMsg: "Usuário e/ou senha inválidos" });
    }
  };

  if (auth.user != null) {
    auth.signout(() => {});
  }

  const handleDisabledButton=()=>{
    fields.every(e=>e) ? setDisabled(false) : setDisabled(true);    
  }

  const handleChange = (e) =>{
    e.target.name != "setChecked" ? eval(e.target.name)(e.target.value) : setChecked(e.target.checked);
  }

  useEffect(() => {
    handleDisabledButton()
  }, fields); // Apenas re-subscribe se props.friend.id mudar

  return (
    <CardCentral 
    sizeHeader="2.8"
    paddingHeaderTop="2.0"
    paddingHeaderBottom="2.4"
    maxHeight="42"
    maxWidth="28"
    >
      <>
        <Typography
          component={"span"}
          className={classes.header}
          variant="h5"
          gutterBottom>
          Cadastra-se!
        </Typography>
        <form className={classes.form} onSubmit={entrar}>
        <div className={classes.margin}>
            <TextField
              error={error.isError}
              size="small"
              label="Nome Completo"
              variant="outlined"
              type="text"
              fullWidth={true}
              helperText={error.erroMsg}
              name="setName"
              value={name}
              onChange={handleChange}
            />
          </div>
          <div className={classes.margin}>
            <TextField
              error={error.isError}
              size="small"
              label="CPF ou CNPJ"
              variant="outlined"
              type="text"
              fullWidth={true}
              helperText={error.erroMsg}
              name="setDocument"
              value={document}
              onChange={handleChange}
            />
          </div>
          <div className={classes.margin}>
            <TextField
              error={error.isError}
              size="small"
              label="Email"
              variant="outlined"
              type="text"
              name="setEmail"
              fullWidth={true}
              value={email}
              onChange={handleChange}
            />
          </div>
          <div className={classes.margin}>
            <TextField
              error={error.isError}
              size="small"
              label="Defina sua senha"
              variant="outlined"
              type="password"
              name="setPassword"
              fullWidth={true}
              helperText={error.erroMsg}
              value={password}
              onChange={handleChange}
            />
          </div>
          <div className={classes.margin}>
            <TextField
              error={error.isError}
              size="small"
              label="Confirme sua senha"
              variant="outlined"
              type="password"
              name="setPassWordConfirmation"
              fullWidth={true}
              helperText={error.erroMsg}
              value={passwordConfirmation}
              onChange={handleChange}
            />
          </div>
          <div className={classes.footer}>
          <FormControlLabel
              control={
                <Checkbox
                checked={checked}
                onChange={handleChange}
                name="setChecked"
                value={checked}/*checked={state.gilad} onChange={handleChange}*/
                />
              }
              label={<span>Li e aceito os <Link component={RouterLink} to="/login" color="secondary">termos e condições</Link></span>}
              className={classes.switch}
            />
            <div className={`${classes.margin} ${classes.subForm} ${classes.footer}`}>
            <FormControlLabel
              control={
                <div style={{marginLeft:"12px"}}>
                <Typography
                  component={"p"}
                  variant="body2"
                  >
                  <Link component={RouterLink} to="/login" color="secondary">
                  Voltar para o Entrar
                  </Link>
                </Typography>
              </div>
              }
              className={classes.switch}
            />           
            <Button type="submit" variant="contained" color="primary" disabled={disabled}>
              Continuar
            </Button>
          </div>
        </div> 
        </form>
     
      </>
    </CardCentral>
  );
};

export default SingUp;
